import { useParams, createFileRoute } from "@tanstack/react-router";
import { useCategory, useClozeSentences } from "@/lib/api/vocabulary";
import { useClozeSentenceRegeneration } from "@/features/vocabulary";
import { ClozeSentencesTable } from "@/widgets/vocabulary/cloze-sentences-table";
import { useLoadingIndicator } from "@/lib/hooks/use-loading-indicator";
import { Header } from "@/components/shared/header";
import { PageContainer } from "@/components/shared/page-container";

function ClozeSentencesPage() {
  const params = useParams({ strict: false });
  const categoryId = params.id as string;

  const { data: category, isLoading: isCategoryLoading } =
    useCategory(categoryId);
  const { data: sentencesData, isLoading: isSentencesLoading } =
    useClozeSentences(categoryId);
  const sentences = sentencesData?.sentences;
  const {
    selectedWordIds,
    toggle,
    regenerate,
    isRegenerating,
    maxCount,
  } = useClozeSentenceRegeneration(categoryId);

  useLoadingIndicator(isCategoryLoading || isSentencesLoading);

  return (
    <PageContainer>
      <Header
        title="AI 예문 관리"
        description={
          category ? `${category.name}의 빈칸 채우기 예문을 검수합니다.` : ""
        }
      />

      {sentencesData && sentencesData.total > sentencesData.sentences.length && (
        <p className="text-xs text-muted-foreground">
          예문이 많아 최근 {sentencesData.sentences.length}개만 표시합니다 (전체{" "}
          {sentencesData.total}개).
        </p>
      )}
      <ClozeSentencesTable
        sentences={sentences ?? []}
        selectedWordIds={selectedWordIds}
        onToggle={toggle}
        onRegenerate={regenerate}
        isRegenerating={isRegenerating}
        maxCount={maxCount}
      />
    </PageContainer>
  );
}

export const Route = createFileRoute(
  "/_content/vocabulary/categories/$id/sentences/"
)({
  component: ClozeSentencesPage,
});
